import './App.css';
import React, { Suspense } from 'react';
import { BrowserRouter } from 'react-router-dom';
import SiteLoader from './views/components/SiteLoader';
import { message } from 'antd';
import { Spin } from 'antd';
import Loader from './views/components/loader';
import { useValidateToken } from './api-hooks/user';
Spin.setDefaultIndicator(<div><Loader /></div>,);
const LayoutAdmin = React.lazy(() => import('./views/layout/Layout'));
const Login = React.lazy(() => import('./views/pages/Login'));

function App() {

	const { isLoading, isFetching, isError, error } = useValidateToken();

	if (isError && error) {
		message.error(error.message);
	}


	return (
		<BrowserRouter basename="/">
			{
				!isLoading
					? !error && !isFetching
						? <Suspense fallback={<SiteLoader />}><LayoutAdmin /></Suspense>
						: <Suspense fallback={<SiteLoader />}><Login /></Suspense>
					: <SiteLoader />
			}
		</BrowserRouter >
	);
}

export default App;
